import { NgModule } from "@angular/core";
import * as ApiServiceProxies from "./service-proxies";

@NgModule({
    providers: [
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.ChatServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.EditionServiceProxy,
        ApiServiceProxies.FriendshipServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.TenantHomeServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.UserLinkServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.PaymentServiceProxy,
        ApiServiceProxies.DemoUiComponentsServiceProxy,
        ApiServiceProxies.InvoiceServiceProxy,
        ApiServiceProxies.SubscriptionServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.UiCustomizationSettingsServiceProxy,
        // POS Services
        ApiServiceProxies.UnitsOfMeasureServiceProxy,
        ApiServiceProxies.VendorsServiceProxy,
        ApiServiceProxies.PrimaryCategoriesServiceProxy,
        ApiServiceProxies.SecondaryCategoriesServiceProxy,
        ApiServiceProxies.ProductCategoriesServiceProxy,
        ApiServiceProxies.ProductsServiceProxy,
        ApiServiceProxies.VariantsServiceProxy,
        ApiServiceProxies.TaxesServiceProxy,
        ApiServiceProxies.AttributesServiceProxy,
        ApiServiceProxies.CodingPatternSettingsServiceProxy,
        ApiServiceProxies.CurrenciesServiceProxy,
        ApiServiceProxies.StoresServiceProxy,
        ApiServiceProxies.PurchaseInvoicesServiceProxy,
        ApiServiceProxies.TenderTypesServiceProxy,
        ApiServiceProxies.DiscountTypesServiceProxy,
        ApiServiceProxies.DevicesServiceProxy,
        ApiServiceProxies.PCsServiceProxy,
        ApiServiceProxies.MainTransactionServiceProxy,
        ApiServiceProxies.SupervisorShiftsServiceProxy,
        ApiServiceProxies.TerminalsServiceProxy,
        ApiServiceProxies.ReportsServiceProxy,
        ApiServiceProxies.CustomersServiceProxy,
        ApiServiceProxies.CashierShiftsServiceProxy,
        ApiServiceProxies.ImportDataServiceProxy,
        ApiServiceProxies.UpdateImportDataServiceProxy,
        ApiServiceProxies.ImportCustomerDataServiceProxy,
        ApiServiceProxies.ImportRawMaterialDataServiceProxy,
        ApiServiceProxies.OfferServiceProxy,
        ApiServiceProxies.TransferMerchantdiseServiceProxy,
        ApiServiceProxies.StockServiceProxy,
        ApiServiceProxies.ClubServiceProxy,
        ApiServiceProxies.SchemaServiceProxy,
        ApiServiceProxies.LoyalityAccountServiceProxy,
        ApiServiceProxies.ScaleConfigurationServiceProxy,
        ApiServiceProxies.RecipeServiceProxy,
        ApiServiceProxies.SaleTypeServiceProxy,
        ApiServiceProxies.RawMaterialServiceProxy,
        ApiServiceProxies.InventoryTransferServiceProxy,
        ApiServiceProxies.CountedStockServiceProxy,
        ApiServiceProxies.CountedStockRetailServiceProxy,
        ApiServiceProxies.StockAdjustmentServiceProxy,
        ApiServiceProxies.ScaleConfigurationServiceProxy,
        ApiServiceProxies.PriceListServiceProxy,
        ApiServiceProxies.SaleTypeServiceProxy,
        ApiServiceProxies.TableServiceProxy,
        ApiServiceProxies.CornerServiceProxy,
        ApiServiceProxies.ComboGroupServiceProxy,
        ApiServiceProxies.PeriodServiceProxy,
        ApiServiceProxies.RawMaterialServiceProxy,
        ApiServiceProxies.DeliveryZoneServiceProxy,
        ApiServiceProxies.DeliveryStreetsServiceProxy,
        ApiServiceProxies.ServiceChargeServiceProxy,
        ApiServiceProxies.MenuItemServiceProxy,
        ApiServiceProxies.RecipeServiceProxy,
        ApiServiceProxies.BatchRecipeServiceProxy,
        ApiServiceProxies.ReportGroupServiceProxy,
        ApiServiceProxies.ApprovalWorkflowsServiceProxy,
        ApiServiceProxies.TransactionTypesServiceProxy,
        ApiServiceProxies.MainTransactionSettingsServiceProxy,
        ApiServiceProxies.ImportMenuItemDataServiceProxy,
        ApiServiceProxies.FactoryResetServiceProxy,
        ApiServiceProxies.PointsServiceProxy,
        ApiServiceProxies.PromotionServiceProxy,
        ApiServiceProxies.HappyHourServiceProxy,
        ApiServiceProxies.TransactionTemplateServiceProxy,
        ApiServiceProxies.InventoryOrdersServiceProxy,
        ApiServiceProxies.PurchaseInvoiceOrdersServiceProxy,
        // ApiServiceProxies.ImportPurchaseInvoiceOrderDataServiceProxy,
        ApiServiceProxies.TransactionsServiceProxy,
        ApiServiceProxies.GroupsServiceProxy,
        ApiServiceProxies.LevelsServiceProxy,

        ApiServiceProxies.StoreGroupServiceProxy,

        ApiServiceProxies.TenantZatcaIntegrationServiceProxy,
        ApiServiceProxies.ZatcaIntegrationServiceProxy,
        ApiServiceProxies.ZatcaCertificateServiceProxy,
        ApiServiceProxies.StoreMenuItemConfigServiceProxy,
        ApiServiceProxies.ComboMealsServiceProxy,
        ApiServiceProxies.ComboMealDefinitionsServiceProxy,
        ApiServiceProxies.TenderTypeMastersServiceProxy,
        ApiServiceProxies.PromotionServiceProxy,
        ApiServiceProxies.PromotionFBServiceProxy,
        ApiServiceProxies.AreaServiceProxy,
        ApiServiceProxies.CodingPatternSettingsServiceProxy,
        ApiServiceProxies.EndOfDayServiceProxy,
        ApiServiceProxies.MsDynamicServiceProxy,
        ApiServiceProxies.SettingsServiceProxy,
        ApiServiceProxies.BusinessCentralServiceProxy,
        ApiServiceProxies.ZatcaTransactionServiceProxy,
        ApiServiceProxies.ImportVariantDataServiceProxy,
        ApiServiceProxies.RefundResonsServiceProxy,
        ApiServiceProxies.ParentTenantReportServiceProxy,
        ApiServiceProxies.InventoryReportsServiceProxy,
        ApiServiceProxies.SalesReportsServiceProxy,
        ApiServiceProxies.UserLogServiceProxy,
        ApiServiceProxies.ThemeSettingsServiceProxy,
        ApiServiceProxies.QrMenaMenuItemServiceProxy,
        ApiServiceProxies.QrMenaCategoriesServiceProxy,
        ApiServiceProxies.QrMenaSaleTransactionServiceProxy,
        ApiServiceProxies.ImportInventoryOrderDataServiceProxy,
        ApiServiceProxies.TenantDeviceServiceProxy,
        ApiServiceProxies.DeviceManagmentReportsServiceProxy
    ],
})
export class ServiceProxyModule {}



// WEBPACK FOOTER //
// ./src/shared/service-proxies/service-proxy.module.ts